export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/manga.30f6f0a.png";